import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import MainContext from '../../Context';
import normalizeStaticHostName from '../../helpers/normalizeStaticHostName';
import { useFeatureFlag } from '../../hooks';
import { ApiProvider } from '../../hooks/machines/useApiMachine';
import useMainMachine from '../../hooks/machines/useMainMachine';
import ModalContent from './ModalContent';
const MakePaymentCore = ({ accountId, accountLast4, apiErrorCallback, featureFlags, headerRef, handleClose, handleCloseOnConversion, helpNumber, hosts, isOpen, lang, triggerAnalyticsEvent }) => {
    const normalizedFeatureFlags = useFeatureFlag(featureFlags);
    const queryClient = useQueryClient();
    const apiConfig = useMemo(() => ({
        config: {
            apiErrorCallback,
            hosts,
            lang
        },
        keyProps: {
            accountId,
            accountIdType: 'guid'
        },
        queryOptions: Object.assign(Object.assign({}, queryClient.getQueryDefaults()), { enabled: isOpen })
    }), [accountId, apiErrorCallback, hosts, isOpen, lang, queryClient]);
    const baseContext = useMemo(() => ({
        apiConfig,
        featureFlags: normalizedFeatureFlags,
        handleClose,
        handleCloseOnConversion,
        helpNumber,
        isOpen,
        triggerAnalyticsEvent
    }), [
        apiConfig,
        handleClose,
        handleCloseOnConversion,
        helpNumber,
        isOpen,
        normalizedFeatureFlags,
        triggerAnalyticsEvent
    ]);
    const [{ context: { apiMachineRef } }, sendToMainMachine, mainService] = useMainMachine(baseContext);
    const mainContextValues = useMemo(() => (Object.assign(Object.assign({}, baseContext), { accountId,
        accountLast4,
        sendToMainMachine, staticHostName: normalizeStaticHostName(hosts), triggerAnalyticsEvent })), [
        accountId,
        accountLast4,
        baseContext,
        hosts,
        sendToMainMachine,
        triggerAnalyticsEvent
    ]);
    return (_jsx(MainContext.Provider, Object.assign({ value: mainContextValues }, { children: _jsx(ApiProvider, Object.assign({ value: apiMachineRef }, { children: _jsx(ModalContent, { headerRef: headerRef, mainService: mainService }) })) })));
};
export default MakePaymentCore;
